/** One claim or advance row on the settlement page; the applied amount is fixed to the outstanding for now. */
export interface ExpenseSettlementLineFormModel {
  reference: string;
  number: string;
  total: number;
  outstanding: number;
  selected: boolean;
  appliedAmount: number;
}

/** The settlement page's header fields; the claim and advance rows live in their own form arrays. */
export interface ExpenseSettlementFormModel {
  settlementDate: Date | null;
  bankAccount: string | null;
  bankingReference: string | null;
  bankingFee: number | null;
  securityFee: number | null;
  note: string | null;
}

export const expenseSettlementFieldLabels: Record<keyof ExpenseSettlementFormModel, string> = {
  settlementDate: 'ExpenseSettlement_Field_Date',
  bankAccount: 'BankCharges_BankAccount',
  bankingReference: 'BankCharges_Reference',
  bankingFee: 'BankCharges_BankingFee',
  securityFee: 'BankCharges_SecurityFee',
  note: 'ExpenseSettlement_Field_Note',
};
